import { createSelector } from 'reselect';

const getAuthState = state => state.profile;


export const selectFlags = createSelector(getAuthState, state => state.flags);

export const selectProfile = createSelector(getAuthState, state => state.profile);
export const selectCompany = createSelector(getAuthState, state => state.company);
